import React from 'react'
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import UserStatus from '../UserStatus';

function UserStatusLayout() {
  return (
    <>
      <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            minHeight: '100vh',
            overflow: 'auto',
            marginLeft: { xs: 0, sm: "64px", md: "280px" }, // Account for fixed sidebar
            paddingTop: { xs: "80px", sm: "80px", md: "80px" }, // Account for fixed header
            transition: "margin-left 0.3s ease",
          }}
        >
          <Container maxWidth="xl" sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
           <UserStatus/>
          </Container>
        </Box>
    </>
  )
}

export default UserStatusLayout;
